import { render } from "./LevelIntervalAlert.vue?vue&type=template&id=cbd587e4"
import script from "./LevelIntervalAlert.vue?vue&type=script&lang=js"
export * from "./LevelIntervalAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/level/LevelIntervalAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbd587e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbd587e4', __exports__)) {
    console.log('reload')
    api.reload('cbd587e4', __exports__)
  }
  
  module.hot.accept("./LevelIntervalAlert.vue?vue&type=template&id=cbd587e4", () => {
    console.log('re-render')
    api.rerender('cbd587e4', render)
  })

}


export default __exports__